import React, {Component} from 'react'
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {Upload, Icon} from "antd";
import Auth from "../util/auth";

class FileUpload extends Component {

    static propTypes = {
        name: PropTypes.string,
        dispatch: PropTypes.func,
        multiple: PropTypes.bool,
        action: PropTypes.string,
        onError: PropTypes.func,
        onSuccess: PropTypes.func.isRequired,
        path: PropTypes.string.isRequired
    };
    static defaultProps = {
        name: 'file',
        multiple: true,
        action: '//jsonplaceholder.typicode.com/posts/',
        onError: (info) => {},
    };

    componentWillMount = () => {
        //Make sure you are logged in still, else this fails!
        const authInst = Auth.getInstance();
        if(!authInst._getDecodedToken()){
            this.props.dispatch({type: 'LOGOUT'});
            authInst._setToken(authInst._getEmptyToken());
            window.location.reload();
        }
    }

    render() {
        const {
            name,
            multiple,
            action,
            onError,
            onSuccess,
            path
        } = this.props;

        return (
            <Upload.Dragger
                name={name}
                multiple={multiple}
                action={action}
                onChange={(info) => {
                    const status = info.file.status;
                    if (status === 'done') {
                        onSuccess(info);
                    } else if (status === 'error') {
                        onError(info);
                    }
                }}
                headers={{
                    'X-Requested-With': 'Benchmark Wijzijnopgewekt',
                    Authorization: `Bearer ${Auth.getInstance()._getToken()}`
                }}
                data={{
                    path: path
                }}>
                <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                </p>
                <p className="ant-upload-text">Klik hier of sleep bestanden in dit vlak</p>
                <p className="ant-upload-hint">Upload hiermee de bestanden voor deze klant</p>
            </Upload.Dragger>
        )
    }
}

let mapStateToProps = state => ({
    authToken: state.malfunctions.token,
    dispatch: state.dispatch
});

export default connect(mapStateToProps)(FileUpload);




// WEBPACK FOOTER //
// ./src/components/FileUpload.js